import styled from 'styled-components';

export const OrderSummaryWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const RightColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  max-width: 550px;
  min-width: 432px;
`;
